import Swiper, { Navigation, Pagination } from 'swiper'

Swiper.use([ Navigation ]);
Swiper.use([ Pagination ]);

var swiper = new Swiper('.contextual-publications .swiper-container', 
{

    spaceBetween: 30,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,

    },
    watchOverflow: true
});
